import { GetUnidadeDeNegocioService } from '@/features/regionais/services/get-unidade-de-negocio.service'
import { regionaisKeys } from '@/features/regionais/utils/queries'
import { usePrefetch } from '@/shared/hooks/use-prefetch'

export const usePrefetchRegionais = () => {
  return usePrefetch({
    queryKey: regionaisKeys.listas(),
    queryFn: () => new GetUnidadeDeNegocioService().execute().then((response) => response.data),
    staleTime: 60 * 1000 * 5,
  })
}
